<template>
  <div
    class="flex space-x-4 sm:max-w-6xl"
    :class="{
      'mt-12': !isOnboarding,
      'mt-4': isOnboarding,
    }"
  >
    <div class="flex-grow">
      <div
        class="aspect-video min-h-1 rounded-lg bg-black shadow"
        :class="{
          'max-h-[500px]': isOnboarding,
        }"
      >
        <ImageOrVideo :src="galleryPreviewItem" />
      </div>
    </div>
    <div class="relative" style="min-width: 182px">
      <div
        class="absolute inset-0 -mt-2 h-full w-full space-y-4 overflow-y-auto px-2 pt-2"
      >
        <div
          v-for="(item, i) in items"
          class="aspect-video rounded-lg border-2 bg-black shadow"
          :class="{
            'border-primary': galleryPreviewIdx === i,
            'hoverpop cursor-pointer': galleryPreviewIdx !== i,
          }"
        >
          <ImageOrVideo :src="item" @click="onClick(i)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ items: string[]; isOnboarding?: boolean }>();

const galleryPreviewIdx = ref(0);
const galleryPreviewItem = computed(
  () => props.items[galleryPreviewIdx.value] ?? '',
);

const emit = defineEmits<(e: 'selected', value: string, idx: number) => void>();

const onClick = (idx: number) => {
  galleryPreviewIdx.value = idx;
  emit('selected', props.items[idx] ?? '', idx);
};
</script>
